//IfLearnerRead
//学员是否已读
export enum IfLearnerRead {
	'未读' = '0',
	'已读' = '1',
}
export type IfLearnerReadType = keyof typeof IfLearnerRead
export type IfLearnerReadValue = typeof IfLearnerRead[IfLearnerReadType]

//ReqWay
//发起方式
export enum ReqWay {
	'被动反馈' = 0,
	'主动反馈' = 1,
}
export type ReqWayType = keyof typeof ReqWay
export type ReqWayValue = typeof ReqWay[ReqWayType]

//ShelveTimeUnit
//搁置时间单位
export enum ShelveTimeUnit {
	oneWeek = '一周',
	twoWeek = '两周',
	threeWeek = '三周',
	oneMonth = '一个月',
	twoMonth = '两个月',
	threeMonth = '三个月',
}
export type ShelveTimeUnitType = keyof typeof ShelveTimeUnit
export type ShelveTimeUnitValue = typeof ShelveTimeUnit[ShelveTimeUnitType]

//submitWay
//提交反馈类型
export enum SubmitWay {
	feedBack = '提交反馈',
	stageFinish = '阶段完成',
}
export type SubmitWayType = keyof typeof SubmitWay
export type SubmitWayValue = typeof SubmitWay[SubmitWayType]

//teacherResult
//教师处理结果
export enum TeacherResult {
	pass = '优秀',
	notPass = '待改进',
	strive = '再努把力',
	shelve = '搁置',
}
export type TeacherResultType = keyof typeof TeacherResult
export type TeacherResultValue = typeof TeacherResult[TeacherResultType]

//teacherResultOfTest
//教师处理结果
export enum TeacherResultOfTest {
	pass = '通过',
	notPass = '不通过',
	shelve = '搁置',
}

export type TeacherResultOfTestType = keyof typeof TeacherResultOfTest
export type TeacherResultOfTestValue = typeof TeacherResultOfTest[TeacherResultOfTestType]

//teacherStageResult
//教师阶段处理结果
export enum TeacherStageResult {
	normalFinish = '任务正常完成',
	shelve = '任务搁置',
	close = '任务关闭',
}
export type TeacherStageResultType = keyof typeof TeacherStageResult
export type TeacherStageResultValue = typeof TeacherStageResult[TeacherStageResultType]

//queryType
//查询类型
export enum QueryType {
	unRead = '待审核',
	all = '全部',
}
export type QueryTypeType = keyof typeof QueryType
export type QueryTypeValue = typeof QueryType[QueryTypeType]

//taskDifficulty
//任务难度
export enum TaskDifficulty {
	simple = '简单',
	ordinary = '一般',
	challenge = '挑战',
	difficulty = '困难',
}
export type TaskDifficultyType = keyof typeof TaskDifficulty
export type TaskDifficultyValue = typeof TaskDifficulty[TaskDifficultyType]

//feedBackType
//反馈类型
export enum FeedBackType {
	input = '输入',
	test = '测试',
}
export type FeedBackTypeType = keyof typeof FeedBackType
export type FeedBackTypeValue = typeof FeedBackType[FeedBackTypeType]

//learnerResult
//学员处理结果
export enum LearnerResult {
	finish = '完成',
	notFinish = '未完成',
}
export type LearnerResultType = keyof typeof LearnerResult
export type LearnerResultValue = typeof LearnerResult[LearnerResultType]

//reqInitiator
//发起人
export enum ReqInitiator {
	teacher = '教师',
	learner = '学员',
}
export type ReqInitiatorType = keyof typeof ReqInitiator
export type ReqInitiatorValue = typeof ReqInitiator[ReqInitiatorType]
